import React from 'react';
const previews = [{
  src: 'https://cdn.magicpatterns.com/uploads/qzpjFkpeZGYHJaVJTa3ryy/Screenshot_2026-02-13_202516.png',
  alt: 'Módulo 2 – Equipos y Seguridad'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/n96EfXq5cWr3NL6N5jDKB4/Screenshot_2026-02-13_202638.png',
  alt: 'Patrón de Movimiento y Técnica'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oGRVJR9gcq5ZGJYdKQcNo6/Screenshot_2026-02-13_202600.png',
  alt: 'Módulo 6 – Rentabilidad y Estructura de Negocio'
}];
export function PreviewSection() {
  return <section className="py-20 bg-[#FFF8F0]" data-id="element-147">
      <div className="max-w-6xl mx-auto px-4" data-id="element-148">
        <div className="text-center mb-12" data-id="element-149">
          <span className="text-[#BE185D] font-bold tracking-wider uppercase mb-2 block" data-id="element-150">
            👀 Mirá por dentro
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-151">
            Así se ve el contenido real del MegaPack
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-152">
            Material profesional, claro y estructurado. Sin relleno, sin teoría
            innecesaria. Directo a lo que necesitás saber.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-153">
          {previews.map((preview, idx) => <div key={idx} className="rounded-xl overflow-hidden shadow-lg border border-pink-100 bg-white" data-id="element-154">
              <img src={preview.src} alt={preview.alt} className="w-full h-auto" data-id="element-155" />
            </div>)}
        </div>

        <p className="text-center text-sm text-gray-500 mt-8 italic" data-id="element-156">
          * Páginas reales del material incluido en el MegaPack Estética
          Integral
        </p>
      </div>
    </section>;
}